'use es6';

import { trackThreadCreatedMetric } from '../usage-tracking/utils/trackMetric';
export function trackWidgetThreadCreation() {
  trackThreadCreatedMetric();
}